import {useSelector, shallowEqual} from 'react-redux';
import HeaderWithNoAuth from '@jobseeker/feature-navigation/widgets/HeaderNoAuth';
import useInterceptor from '@jobseeker/common-core/hooks/useInterceptor';

import type {AppState} from '@jobseeker/common-core/types';

const HeaderNoAuthHarness = () => {
  const interceptor: any = useInterceptor();
  const page = useSelector((state: AppState) => state.app.page, shallowEqual);

  const isUserLogin: boolean = useSelector(
    (state: AppState) => state.auth.isLoggedIn,
    shallowEqual
  );

  const {
    siteName,
    header: {config, meta},
    proMembership,
  } = interceptor;

  return (
    <HeaderWithNoAuth
      siteName={siteName}
      config={config}
      meta={meta}
      isLoggedIn={isUserLogin}
      page={page}
      subscriptionMeta={proMembership}
    />
  );
};

export default HeaderNoAuthHarness;
